<template>
  <div id="prodsplit">
    <el-popover
      :visible="visible"
      placement="bottom"
      :width="popoverWidth"
      title=""
    >
      <template #reference>
        <div>
          <el-button
            type="text"
            :disabled="disabled"
            @click="openProductionCost(SplitMediaId)"
            class="icon-button popover-button-icon"
          >
            <i
              style="font-size: 18px"
              class="tim-icons icon-coins matrix-icon popover-button-icon"
              :class="{
                disabled: disabled,
              }"
            ></i>
          </el-button>
        </div>
      </template>
      <div
        class="prodsplit"
        style="padding: 10px"
        v-click-outside="productioncost_outsideclick"
      >
        <div class="box">
          <div class="close">
            <el-button
              type="info"
              link
              class="icon-button"
              @click="CloseProoductionCostSplit"
            >
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
          <div style="font-weight: 700; font-size: 17px">
            Production Cost Split
          </div>
        </div>
        <el-form
          :model="ProductionSplit"
          label-width="420px;"
          label-position="rigth"
          style="margin-top: 20px"
        >
          <el-form-item style="margin-top: -20px">
            <!-- <div  style="width:120px; text-align:right;margin-right:20px;">Production Cost</div> -->
            <div>
              <span>{{ `${seqNo + 1}. ${mediaName}` }}</span>
            </div>
          </el-form-item>
          <el-form-item style="margin-top: -20px">
            <div style="width: 150px; margin-left: 470px">
              <span>Qty</span>
            </div>
            <div
              v-for="item in fields"
              :key="item"
              style="width: 250px; margin-left: 20px"
            >
              <span>{{ item.label }}</span>
            </div>
          </el-form-item>
          <el-form-item
            v-for="(item, index) in productionCost"
            :key="index"
            style="margin-top: -20px"
          >
            <div style="width: 155px; text-align: left; margin-right: 20px">
              {{ item.label }}
            </div>
            <base-input
              v-model="item.amount"
              @change="TotalProductionCost"
              class="input-money input-currency-noarea"
              style="width: 250px"
              v-on:input="checkInput"
              :disabled="mode === 'view'"
              ><template #addonLeft>
                <span class="currency"> $ </span>
              </template></base-input
            >
            <div style="width: 20px; text-align: right; margin-right: 20px">
              X
            </div>
            <base-input
              v-model="item.qty"
              @change="TotalProductionCost"
              class="input-money input-currency-noarea"
              style="width: 150px"
              v-on:input="checkInput"
              :disabled="mode === 'view'"
            ></base-input>
            <div
              v-for="field in fields"
              :key="'field' + field"
              style="width: 250px; margin-left: 20px"
            >
              <base-input
                v-model="item[field.code]"
                :disabled="mode === 'view'"
              ></base-input>
            </div>
          </el-form-item>

          <el-form-item style="margin-top: -20px">
            <div style="width: 155px; text-align: left; margin-right: 20px">
              Total
            </div>
            <base-input
              v-model="ProductionSplit.totalCost"
              class="input-money input-currency-noarea"
              style="width: 250px"
              :disabled="true"
              ><template #addonLeft>
                <span class="currency"> $ </span>
              </template></base-input
            >
          </el-form-item>

          <el-form-item
            label=""
            v-if="(mode || 'view') === 'edit' && isShowButton"
          >
            <div style="width: 200px; margin-right: 20px"></div>
            <div>
              <base-button type="primary" @click="saveProductionSplit()"
                >OK</base-button
              >
              <base-button
                @click="CloseProoductionCostSplit()"
                style="margin-left: 30px"
                >Close</base-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-popover>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { ref, onMounted, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { Close } from '@element-plus/icons-vue';

import { useInternalSplitStore } from '@/store/internalsplit';
import { storeToRefs } from 'pinia';
import { ClickOutside as vClickOutside } from '@/assets/js/directive';

const props = defineProps({
  SplitDetailId: {
    type: Number,
  },
  SplitMediaId: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  mediaName: {
    type: String,
    default: '',
  },
  seqNo: {
    type: String,
  },
  mode: {
    type: String,
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
  beforeShow: {
    type: Function,
  },
  productionCostSplits: {
    type: Array,
    description: '制作费用分拆',
  },
  totalCost: {
    type: Number,
    description: '总金额',
  },
  customFields: {
    type: String,
    description: '自定义字段设置',
  },
});

const fields = ref([]);
const isShowButton = ref(true);
const visible = ref(false);
const disable_state = ref(false);
const productionCost = ref([]);
const popoverWidth = ref();

onMounted(() => {
  disable_state.value = props.mode == 'view';
});

// useInternalSplit
const useInternalSplit = useInternalSplitStore();
const ProductionSplit = ref({});
const emits = defineEmits(['save', 'show', 'close']);

//输入必须为正数,
const checkInput = (event) => {
  let input = event.target.value;
  if ((input && isNaN(input)) || parseFloat(input) < 0|| input==' ') {
    // this.$message.error('输入必须为正整数');  || parseFloat(input) % 1 !== 0
    event.target.value = 0;
  }
};
// 合计总制作费用
const TotalProductionCost = () => {
  productionCost.value.forEach((item) => {
    item.amountSum = parseFloat((item.amount * item.qty).toFixed(2));
  });

  if (productionCost.value && productionCost.value.length > 0) {
    ProductionSplit.value.totalCost = productionCost.value
      .map((t) => t.amountSum)
      .reduce((a, b) => a + b);
  }
};

// save: Save Production Cost Split
const saveProductionSplit = async () => {
  const messageConfig = require('@/models/messageConfig');

  // 更新到State
  //useInternalSplit.UpdateProductionSplit();

  // emits
  //emits('save', props.SplitMediaId);
  ProductionSplit.value.prod_cost_split = productionCost.value;
  ProductionSplit.value.custom_fields = JSON.stringify(fields.value);

  emits('save', ProductionSplit.value);

  ElMessage({
    message: messageConfig.dialogOk('Production Cost Split'),
    type: 'success',
  });

  CloseProoductionCostSplit();
};

// event: 隐藏/显示 split
const openProductionCost = (id) => {
  disable_state.value = props.mode == 'view';

  var isBeforeShow = true;
  if (props.beforeShow) {
    isBeforeShow = props.beforeShow(visible.value);
  }

  if (isBeforeShow) {
    visible.value = true;
    isShowButton.value = true;
    emits('show', true, disable_state.value);
    useInternalSplit.getProductionSplit(id);
  }
};

// event: 关闭制作拆分;
const CloseProoductionCostSplit = () => {
  visible.value = false;
  emits('close', false, false);
};

const productioncost_outsideclick = (e) => {
  if (visible.value) {
    if (e.target.attributes?.class?.value?.includes('popover-button-icon')) {
      if (!props.isVisible) {
        CloseProoductionCostSplit();
      }
    } else if (e.target.nodeName == 'BUTTON') {
      if (disable_state.value) {
        CloseProoductionCostSplit();
      }
    } else {
      CloseProoductionCostSplit();
    }
  }
};

const init = () => {
  ProductionSplit.value.splitDetailId = props.SplitDetailId;
  ProductionSplit.value.splitMediaId = props.SplitMediaId;
  ProductionSplit.value.totalCost = props.totalCost;
  productionCost.value = JSON.parse(JSON.stringify(props.productionCostSplits));

  if (!productionCost.value || productionCost.value.length == 0) {
    productionCost.value = JSON.parse(
      JSON.stringify(useInternalSplit.ProductionCostTypes)
    );
    if (productionCost.value && productionCost.value.length > 0) {
      productionCost.value.map((t) => {
        t.qty = 0;
        t.amount = 0;
        t.amountSum = 0;
      });
    }
  }

  if (props.customFields) {
    fields.value = JSON.parse(props.customFields);
  }

  var codes = fields.value.length > 0 ? fields.value.map((t) => t.code) : [];

  var systemFields = useInternalSplit.ProductionCostSplitField.filter(
    (t) => !codes.includes(t.code)
  );
  fields.value = fields.value.concat(systemFields);

  popoverWidth.value = fields.value.length * 250 + 710;
};

watch(
  () => visible.value,
  (new_value) => {
    if (new_value) {
      init();
    }
  },
  { immediate: true }
);
defineExpose({
  close() {
    isShowButton.value = false;
    CloseProoductionCostSplit();
  },
  isActive() {
    return visible.value;
  },
  disable: !visible.value || props.mode === 'view',
});
</script>

<style scoped></style>
